import { render } from "./WordGuess.vue?vue&type=template&id=66922014"
import script from "./WordGuess.vue?vue&type=script&lang=js"
export * from "./WordGuess.vue?vue&type=script&lang=js"

import "./WordGuess.vue?vue&type=style&index=0&id=66922014&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__